<template>
	<div>
	<ul class="apply ovw soak soak_1 info">
		<li class="pad">
			<span>卡号</span>
			<div class="fr">
				<input readonly class="font_c ipt" type="text" v-model="gift.cardID" name="xingming">
				<img src="/static/rt.png" v-if="false" alt="">
			</div>
		</li>
		<li class="pad">
			<span>类别名称</span>
			<div class="fr">
				<input readonly class="font_c ipt" type="text" v-model="gift.groupID_sname" name="xingming">
				<img src="/static/rt.png" v-if="false" alt="">
			</div>
		</li>
		<li class="pad" style="border-bottom:0">
			<span>截止日期</span>
			<div class="fr">
				<input readonly class="font_c ipt" type="text" :value="gift.endDate.split('T')[0]" name="xingming">
				<img src="/static/rt.png" v-if="false" alt="">
			</div>
		</li>
	</ul>
	<div style="height:10px;"></div>
	<ul class="apply ovw soak soak_1 info" v-if="status > 1 && gift.deliveryNo">
		<li class="pad" style="border-bottom:0">
			<span>顺丰 {{gift.deliveryNo}} 快递追踪</span>
		</li>
	</ul>
	<ul class="apply ovw soak soak_1 info" v-if="status > 1">
		<li class="pad" v-for="(item,index2) in express" :key="index2">
			<span style="min-width:120px">{{item.time}}</span>
			<div class="fr">
				<div style="text-align: left;margin-left: 20px;" readonly autocomplete="off" class="font_c ipt">{{item.content}}</div>
				<img src="/static/rt.png" v-if="false" alt="">
			</div>
		</li>
	</ul>
	<div style="height:10px;" v-if="status > 1"></div>
	<ul class="apply ovw soak soak_1 info" v-if="status > 1 && gift.deliveryNo">
		<li class="pad" style="border-bottom:0">
			<span>收货人信息</span>
		</li>
	</ul>
	<ul class="apply ovw soak soak_1 info" v-if="status > 1">
		<li class="pad">
			<span>收货人</span>
			<div class="fr">
				<input readonly autocomplete="off" class="font_c ipt" type="text" v-model="gift.linkMan">
				<img src="/static/rt.png" v-if="false" alt="">
			</div>
		</li>
		<li class="pad">
			<span>手机号</span>
			<div class="fr">
				<input readonly autocomplete="off" class="font_c ipt" type="text" v-model="gift.mobile" name="mobile">
				<img src="/static/rt.png" v-if="false" alt="">
			</div>
		</li>
		<li class="pad">
			<span>详细地址</span>
			<div class="fr">
				<input readonly autocomplete="off" class="font_c ipt" type="text" v-model="gift.address" name="mobile">
				<img src="/static/rt.png" v-if="false" alt="">
			</div>
		</li>
		<li class="pad">
			<span>发货日期</span>
			<div class="fr">
				<input readonly autocomplete="off" class="font_c ipt" type="text" :value="gift.deliveryDate.split('T')[0]" name="mobile">
				<img src="/static/rt.png" v-if="false" alt="">
			</div>
		</li>
		<li class="pad" style="border-bottom:0">
			<span>备注</span>
			<div class="fr">
				<input readonly autocomplete="off" class="font_c ipt" type="text" v-model="gift.deliveryNote" name="mobile">
				<img src="/static/rt.png" v-if="false" alt="">
			</div>
		</li>
	</ul>
	<div style="height:10px;" v-if="status > 1"></div>
	<ul class="apply ovw soak soak_1 info" v-if="status > 1">
		<li class="pad" style="border-bottom:0">
			<span>清单</span>
		</li>
	</ul>
	<ul class="record_list2" v-if="status > 1" style="margin-bottom:0">
		<li>
			<div>
				<div class="product-item" v-for="(item2,index2) in gift.detail" :key="index2"><img :src="'/userfile/default/picture/' + item2.productID_simage" /><span>{{item2.productID_sname}}</span><h3>{{item2.num}}{{item2.productID_unit}}</h3></div>
			</div>
		</li>
	</ul>
	</div>
</template>

<script>
import querystring from 'querystring';
import {
  GiftOrder_OrderDetail
} from "@/api/api.js"
export default {
  data () {
    return {
	  status:0,
	  express:[],
	  giftProduct:{detail:[],sname:''},
	  gift:{CardID:'',endDate:'',detail:[],deliveryNo:''},
	  order:{token: "", linkMan: "", mobile: "",area:"",addressDetail:'', address: "", deliveryNote: "", deliveryDate: "" }
    }
  },
  methods:{
	  loadData(){
		let that = this;
		let token = localStorage.getItem("giftsession");
		if(token) {
			
		}
	}
  },
  created:function(){
	  let that = this;
    let options = querystring.parse(location.search.replace('?', ''));
	  GiftOrder_OrderDetail({ID:options.id},function(res){
		that.gift = res.model;
		that.express = res.extand.Express;
		that.status = res.model.status;
	});
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.record_list2{
  margin-bottom: 0;
  margin-top:0;
}
.detail-btn{
	background-color: #b28b5f;
	border: 1px solid #b28b5f;
    color: #fff;
    padding: 0.01rem;
    border-radius: 3px;
	display: block;
	width:100%;
	text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/wechat/giftorderdetail.vue